import { type Message } from '../types';

export type MessageActionResolutions = 'confirm' | 'cancel' | 'actioned';
export type MessageActionInvocationStatus =
	| 'planned'
	| 'started'
	| 'finished'
	| 'cancelled'
	| 'errored';

export type MessageAction = {
	key: string;
	invocationId: string;
	data: unknown;
	actionId?: string;
	status?: MessageActionInvocationStatus;
};

export type MessageActionPayload = {
	context: MessageAction & {
		messageId: string;
		recipient_agent_named_id?: string;
		resolution: {
			type: MessageActionResolutions;
			message?: string;
		};
	};
};

export type MessageActionResponse = {
	message: Message;
};

type ContentCreateStreamActionData = {
	contentPart: string;
};

export function isContentStreamActionData(data: unknown): data is ContentCreateStreamActionData {
	return typeof data === 'object' && data !== null && 'contentPart' in data;
}
